import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processedRef = React.useRef(false);

  useEffect(() => {
    if (processedRef.current) return;
    processedRef.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const session_id = match ? decodeURIComponent(match[1]) : null;

    (async () => {
      if (!session_id) { navigate("/login"); return; }
      try {
        const { data } = await api.post("/auth/session", { session_id });
        if (data.token) localStorage.setItem("fripri_logged_in", "1");
        setUser(data.user);
        window.history.replaceState(null, "", "/");
        navigate("/dashboard", { state: { user: data.user }, replace: true });
      } catch (e) {
        navigate("/login");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-black text-white" data-testid="auth-callback">
      <div className="text-center">
        <h1 className="text-4xl font-black tracking-tighter mb-3">Connexion…</h1>
        <p className="label text-[color:var(--color-mint)]">Un instant</p>
      </div>
    </div>
  );
}
